// @vendors
import { useContext } from "react"
import { Form, Radio } from 'antd'
import Context from '../../../context/appContext';
import TitleDescription from "../title-description";

export default function RadioImageField({ info, key, form }) {

    const validate = info.validate ? info.validate : {};
    const { dataForm: { formResponses, hiddenFields, disabledFields } } = useContext(Context);

    const getDefaultValue = () => {
        const indexValue = formResponses.findIndex(x => x.key === info.key)
        const value = indexValue !== -1 && formResponses[indexValue] && formResponses[indexValue].value ? formResponses[indexValue].value : null
        form.setFieldsValue({ [info.key]: value });
        onChange({ target: { value: value } })
        return info.value
    }

    const optionsImages = (optInfo, option) => {
        let images = "";
        const infoGender = formResponses.find(x => x.key == "genero");
        if (infoGender && optInfo.key === "claveTipoAsegurados") {
            const gender = infoGender.value;
            images = option && option.value === "T" ? infoGender.properties[gender] : optInfo.properties[option.value];
        } else {
            images = optInfo.properties[option.value];
        }
        return images;
    }

    const onChange = (event) => {
        const value = event.target.value;
        info.value = value;
        const index = formResponses.findIndex(x => x.key === info.key);
        index != -1 ? formResponses[index].value = value : formResponses.push(info);
    }

    return (
        <div>
            <TitleDescription info={info} />
            <Form.Item
                label=''
                name={info.key}
                key={key}
                hidden={hiddenFields[info.key]}
                rules={[
                    {
                        required: hiddenFields[info.key] || disabledFields[info.key] || info.disabled ? false : validate.required,
                        message: 'Este campo es requerido'
                    }
                ]}
                className='radio-image'
            >
                <Radio.Group
                    className='ant-radio-group-image'
                    disabled={disabledFields[info.key]}
                    onChange={onChange}
                    defaultValue={getDefaultValue}
                >
                    {info.values.map((option, index) => (
                        <Radio
                            value={option.value}
                            key={`radio-option-${index}`}
                        >
                            <div className="ant-radio-group-image-container">{info.properties && <img src={optionsImages(info, option)} alt={option.label} />}</div>
                            <label className='ant-label'>
                                {option.label}
                            </label>
                        </Radio>
                    ))}
                </Radio.Group>
            </Form.Item>
        </div>
    )
}